import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  pageTitle: {
    id: 'instruct.grading.pageTitle',
    defaultMessage: 'Grading Tools',
    description: 'Title for the grading page'
  },
  configurationAlt: {
    id: 'instruct.grading.configurationAlt',
    defaultMessage: 'Grading Configuration and Settings',
    description: 'Alt text for the configuration icon button'
  },
  viewGradebook: {
    id: 'instruct.grading.viewGradebook',
    defaultMessage: 'View Gradebook',
    description: 'Text for the button to view the gradebook'
  },
  singleLearner: {
    id: 'instruct.grading.singleLearner',
    defaultMessage: 'Single Learner',
    description: 'Single Learner button label to display corresponding grading tools'
  },
  allLearners: {
    id: 'instruct.grading.allLearners',
    defaultMessage: 'All Learners',
    description: 'All learners button label to display corresponding grading tools'
  },
  descriptionSingleLearner: {
    id: 'instruct.grading.descriptionSingleLearner',
    defaultMessage: 'These grading tools allow for grade review and adjustment for a specific learner on a specific problem.',
    description: 'Description for single learner grading tools'
  },
  descriptionAllLearners: {
    id: 'instruct.grading.descriptionAllLearners',
    defaultMessage: 'These grading tools allow for grade review and adjustment all enrolled learners on a specific problem.',
    description: 'Description for all learners grading tools'
  },
  gradingConfiguration: {
    id: 'instruct.grading.gradingConfiguration',
    defaultMessage: 'Grading Configuration',
    description: 'Title for the grading configuration modal'
  },
  close: {
    id: 'instruct.grading.modals.close',
    defaultMessage: 'Close',
    description: 'Text for the close button in the grading configuration modal'
  },
  viewGradingConfiguration: {
    id: 'instruct.grading.viewGradingConfiguration',
    defaultMessage: 'View Grading Configuration',
    description: 'View grading configuration menu item label'
  },
  viewCourseGradingSettings: {
    id: 'instruct.grading.viewCourseGradingSettings',
    defaultMessage: 'View Course Grading Settings',
    description: 'View course grading settings menu item label'
  },
  noGradingConfiguration: {
    id: 'instruct.grading.noGradingConfiguration',
    defaultMessage: 'No grading configuration found for this course.',
    description: 'Message to display when there is no grading configuration for the course'
  },
  resetAttempts: {
    id: 'instruct.grading.resetAttempts',
    defaultMessage: 'Reset Attempts',
    description: 'Title for the reset attempts action card'
  },
  resetAttemptsDescription: {
    id: 'instruct.grading.resetAttemptsDescription',
    defaultMessage: 'Allow a learner who has used up all attempts to work on the problem again.',
    description: 'Description for the reset attempts action card'
  },
  resetAttemptsButtonLabel: {
    id: 'instruct.grading.resetAttemptsButtonLabel',
    defaultMessage: 'Reset Attempts to Zero',
    description: 'Button label for the reset attempts action card'
  },
  rescoreSubmission: {
    id: 'instruct.grading.rescoreSubmission',
    defaultMessage: 'Rescore Submission',
    description: 'Title for the rescore submission action card'
  },
  rescoreSubmissionDescription: {
    id: 'instruct.grading.rescoreSubmissionDescription',
    defaultMessage: 'For the specified problem, two tools exist for rescoring learner responses.',
    description: 'Description for the rescore submission action card'
  },
  rescoreSubmissionButtonLabel: {
    id: 'instruct.grading.rescoreSubmissionButtonLabel',
    defaultMessage: 'Rescore Learner\'s Submission',
    description: 'Button label for the rescore submission action card'
  },
  rescoreIfImprovesScoreButtonLabel: {
    id: 'instruct.grading.rescoreIfImprovesScoreButtonLabel',
    defaultMessage: 'Rescore Only if Score Improves',
    description: 'Button label for the rescore if improves score action in the rescore submission'
  },
  overrideScore: {
    id: 'instruct.grading.overrideScore',
    defaultMessage: 'Override Score',
    description: 'Title for the override score action card'
  },
  overrideScoreDescription: {
    id: 'instruct.grading.overrideScoreDescription',
    defaultMessage: 'For the specified problem, override the learner\'s score. Input the new score, out of the total points available for this problem.',
    description: 'Description for the override score action card'
  },
  overrideScoreButtonLabel: {
    id: 'instruct.grading.overrideScoreButtonLabel',
    defaultMessage: 'Override Learner\'s Score',
    description: 'Button label for the override score action card'
  },
  deleteHistory: {
    id: 'instruct.grading.deleteHistory',
    defaultMessage: 'Delete History',
    description: 'Title for the delete history action card'
  },
  deleteHistoryDescription: {
    id: 'instruct.grading.deleteHistoryDescription',
    defaultMessage: 'For the specified problem, permanently and completely delete the learner\'s answers and scores from the database.',
    description: 'Description for the delete history action card'
  },
  deleteHistoryButtonLabel: {
    id: 'instruct.grading.deleteHistoryButtonLabel',
    defaultMessage: 'Delete Learner\'s State',
    description: 'Button label for the delete history action card'
  },
  taskStatus: {
    id: 'instruct.grading.taskStatus',
    defaultMessage: 'Task Status',
    description: 'Title for the task status action card'
  },
  taskStatusDescription: {
    id: 'instruct.grading.taskStatusDescription',
    defaultMessage: 'Show the status for the tasks that you submitted for this problem.',
    description: 'Description for the task status action card'
  },
  taskStatusButtonLabel: {
    id: 'instruct.grading.taskStatusButtonLabel',
    defaultMessage: 'Show Task Status',
    description: 'Button label for the task status action card'
  },
  specifyProblem: {
    id: 'instruct.grading.specifyProblem',
    defaultMessage: 'Specify Problem:',
    description: 'Label for the specify problem input field'
  },
  select: {
    id: 'instruct.grading.select',
    defaultMessage: 'Select',
    description: 'Label for the select button in the specify problem field'
  },
  overrideScorePlaceholder: {
    id: 'instruct.grading.overrideScorePlaceholder',
    defaultMessage: 'Score',
    description: 'Placeholder text for the override score input field'
  },
  resetAllLearnersAttemptsDescription: {
    id: 'instruct.grading.resetAllLearnersAttemptsDescription',
    defaultMessage: 'Allows all learners to work on the problem again.',
    description: 'Description for the reset attempts action card in the all learners view'
  },
  rescoreSubmissionAllLearnersDescription: {
    id: 'instruct.grading.rescoreSubmissionAllLearnersDescription',
    defaultMessage: 'For the specified problem, rescore all learners\' responses.',
    description: 'Description for the rescore submission action card in the all learners view'
  },
  rescoreAllSubmissionButtonLabel: {
    id: 'instruct.grading.rescoreAllSubmissionButtonLabel',
    defaultMessage: 'Rescore All Learners\' Submissions',
    description: 'Button label for the rescore submission action card in the all learners view'
  },
  currentScore: {
    id: 'instruct.grading.currentScore',
    defaultMessage: 'Current Score',
    description: 'Label for the current score displayed in the single learner view'
  },
  viewProgress: {
    id: 'instruct.grading.viewProgress',
    defaultMessage: 'View Progress Page',
    description: 'Label for the view progress button displayed next to the current score in the single learner view'
  },
  score: {
    id: 'instruct.grading.score',
    defaultMessage: 'Score',
    description: 'Label for the score displayed in the current status section of the single learner view'
  },
  attempts: {
    id: 'instruct.grading.attempts',
    defaultMessage: 'Attempts',
    description: 'Label for the attempts displayed in the current status section of the single learner view'
  },
  rescore: {
    id: 'instruct.grading.rescore',
    defaultMessage: 'Rescore',
    description: 'Label for the rescore confirmation action'
  },
  resetAttemptsConfirmation: {
    id: 'instruct.grading.resetAttemptsConfirmation',
    defaultMessage: 'Reset attempts for {student} on problem "{blockId}"?',
    description: 'Confirmation message for resetting attempts'
  },
  overrideScoreConfirmation: {
    id: 'instruct.grading.overrideScoreConfirmation',
    defaultMessage: 'Override score for {student} for problem "{blockId}"?',
    description: 'Confirmation message for overriding score'
  },
  deleteStateConfirmation: {
    id: 'instruct.grading.deleteStateConfirmation',
    defaultMessage: 'Delete state for student "{student}" on problem "{blockId}"?',
    description: 'Confirmation message for deleting state'
  },
  rescoreConfirmation: {
    id: 'instruct.grading.rescoreConfirmation',
    defaultMessage: 'Rescore problem for {student} for "{blockId}"?',
    description: 'Confirmation message for rescoring a submission'
  },
  deleteStateButtonLabel: {
    id: 'instruct.grading.deleteStateButtonLabel',
    defaultMessage: 'Delete State',
    description: 'Button label for the delete state confirmation action'
  },
  resetAttemptsSuccess: {
    id: 'instruct.grading.resetAttemptsSuccess',
    defaultMessage: 'Successfully reset problem attempts for {student} on problem "{blockId}".',
    description: 'Success message for resetting attempts'
  },
  overrideScoreSuccess: {
    id: 'instruct.grading.overrideScoreSuccess',
    defaultMessage: 'Started task to override the score for {student} on problem "{blockId}". \n \n Click the \'Show Task Status\' button to see the status of the task.',
    description: 'Success message for overriding score'
  },
  rescoreSubmissionSuccess: {
    id: 'instruct.grading.rescoreSubmissionSuccess',
    defaultMessage: 'Successfully started task to rescore problem "{blockId}" for {student}. \n \n Click the \'Show Task Status\' button to see the status of the task.',
    description: 'Success message for rescoring submission'
  },
  deleteHistorySuccess: {
    id: 'instruct.grading.deleteHistorySuccess',
    defaultMessage: 'State for student "{student}" successfully deleted.',
    description: 'Success message for deleting history'
  },
  unexpectedError: {
    id: 'instruct.grading.unexpectedError',
    defaultMessage: 'An unexpected error occurred. Please try again.',
    description: 'Message to display when an unexpected error occurs'
  }
});

export default messages;
